import React from 'react';

import { ITeacher } from 'modules/courses';

import FirstSection from './first-section';
import Info from './info';

interface IProps {
  teacher?: ITeacher;
}

const About: React.FC<IProps> = ({ teacher }) => (
  <div className="space-y-3">
    <FirstSection
      name={teacher?.full_name}
      birthday={teacher?.birthday}
      image={teacher?.image?.small}
      rating={teacher?.rating || 0}
      studentCount={teacher?.students_count}
      solvedTestsCount={teacher?.solved_tests_count}
      courseStudentsCount={teacher?.course_students_count}
      addressName={teacher?.address?.name}
    />
    <Info description={teacher?.description} />
    {/* <Education education={teacher?.education} /> */}
  </div>
);

export default About;
